<template>
    <div class="flex items-center gap-2">
        <span v-if="isProgressNumberVisible" class="text-sm font-semibold" :class="progressNumberColor"
            >{{ progress }}{{ progressSuffix }}</span
        >
        <div class="w-full h-2 rounded bg-gray-200">
            <div class="h-full rounded" :class="barColor" :style="`width: ${progress}%`"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    progress: number
    barColor: string
    progressSuffix?: string
    isProgressNumberVisible?: boolean
    progressNumberColor?: string
}

withDefaults(defineProps<Props>(), {
    progressNumberColor: "text-primary-color-700",
})
</script>

<style scoped></style>
